export const Validations = {
	MAX_INT_32: 2147483647,
};
